import { Module } from "vuex";
import store, { RootState } from "..";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { IVenderStore } from "@/interfaces/vendor";
import {
  getChecklistRequestedComplianceTypeValues,
  getChecklistRequestedTemplate,
  getRequestAssessmentAttachment,
  getRequestedAssessment,
  getRequestedDetailItem,
  getRequestedEmailGrant,
  getRequestedTemplateDetail,
  getVendorRequestedExternalInput,
  postChecklistRequested,
  postChecklistRequestedGetSecret,
  putChecklistRequested,
  updateRequestedAssessment,
  updateChecklistRequestedEmailGrant,
  createChecklistRequestedStatus,
  getRequestVendorAssessmentAttachment,
  putRequestedUpdatedItems,
  getChecklistRequestedEmailGrants,
  postVendorProviders,
} from "@/services/vendor";
import get from "lodash/get";
import { Org, Vendor } from "@/services/apiRoutes/routes";
import {
  assessmentAdditionalInfoType,
  successStatusCodes,
  checklistRequestedStatusId,
  ExceptionTypes,
  VENDOR_TEMPLATE_API_STATUS,
  localStorageKey,
} from "@/utils/constants";
import {
  convertUTCTimeToLocalTime,
  fileSizeFormat,
} from "@/utils/dateTimeUtils";
import router from "@/router";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { getComponentUiText } from "@/utils/utilities";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getWizardQuestion } from "@/services/wizard";

const vendorModule: Module<IVenderStore, RootState> = {
  namespaced: true,
  state() {
    return {
      requestedChecklist: [],
      checklistRequestedId: null,
      secret: "",
      checklistRequestedTemplate: [],
      checklistRequestedTemplateDetail: [],
      checklistComplianceTypeValues: [],
      checklistComplianceTypeValuesClra: [],
      recentSearch: [],
      requestedDetailItem: {},
      isLoadingRequestedItem: false,
      checklistRequestedTemplateDetailLoading: false,
      isShowButton: false,
      isUpdateQuestionItem: false,
      templateEditId: null,
      isExitsTemplateName: false,
      checklistVendorRequestedExternalInput: {},
      addTemplateItemStatus: [],
      requestedUpdatedItems: [],
      requestedUpdatedChecklist: {},
      isCheckStatusInprogAndWait: false,
      isUpdateRequestedItemsDone: false,
      isChecklistReviewStatusInprogAndWait: false,
      isLoadinggetRequestedTemplate: false,
      isShowArchivedChecklist: false,
      isShowArchivedTemplate: false,
      includeHomeOrgTemplate: false,
      isLoadingRequestedInput: false,
      listProvider: [],
      isLoadingCurrentVendors: false,
      totalRequestedChecklistArchived: 0,
    };
  },

  getters: {
    isCheckQuestionInTemplate: (state) => {
      if (state.checklistRequestedTemplateDetail.length === 0) return false;
      return (
        state.checklistRequestedTemplateDetail[0]?.items?.filter((item) => {
          return (
            item.itemMasterIsArchived === false &&
            item.itemMasterIsHeading === false
          );
        }).length > 0
      );
    },
    isCheckStatusInprogAndWait: (state) => {
      return (
        state.checklistVendorRequestedExternalInput.statusId ===
          checklistRequestedStatusId.inProgress ||
        state.checklistVendorRequestedExternalInput.statusId ===
          checklistRequestedStatusId.waiting
      );
    },
    isChecklistReviewStatusInprogAndWait: (state) => {
      return (
        state.requestedDetailItem?.checklistsRequested[0].statusId ===
          checklistRequestedStatusId.inProgress ||
        state.requestedDetailItem?.checklistsRequested[0].statusId ===
          checklistRequestedStatusId.waiting
      );
    },
  },

  mutations: {
    INITIAL: (state) => {
      const isArchivedAssessment = localStorage.getItem(
        localStorageKey.vendorManageShowArchivedAssessment,
      );

      const showArchivedTemplate = localStorage.getItem(
        localStorageKey.vendorManageShowArchivedTemplate,
      );

      const homeOrgTemplate = localStorage.getItem(
        localStorageKey.vendorManageIncludeHomeOrgTemplate,
      );

      state.isShowArchivedChecklist =
        isArchivedAssessment && isArchivedAssessment.toLowerCase() === "true"
          ? true
          : false;

      state.isShowArchivedTemplate =
        showArchivedTemplate && showArchivedTemplate.toLowerCase() === "true"
          ? true
          : false;

      state.includeHomeOrgTemplate =
        homeOrgTemplate && homeOrgTemplate.toLowerCase() === "true"
          ? true
          : false;
    },
    SET_REQUESTED_CHECKLIST: (state, payload) => {
      function groupAndSortByProvider(data) {
        const grouped = data.reduce((acc, item) => {
          const key = item.providerId;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        const result: any = [];
        Object.values(grouped).forEach((group: any) => {
          group.sort(
            (a, b) =>
              new Date(b.dateAdded).getTime() - new Date(a.dateAdded).getTime(),
          );

          const latestItem = { ...group[0] };
          latestItem.checklistRequestedHistory = [...group];

          result.push(latestItem);
        });

        return result;
      }
      state.requestedChecklist = groupAndSortByProvider(payload);
    },
    SET_SECRET: (state, payload) => {
      state.secret = payload;
    },
    SET_CHECKLIST_REQUESTED_ID: (state, payload) => {
      state.checklistRequestedId = payload;
    },
    SET_CHECKLIST_REQUESTED_TEMPLATE: (state, payload) => {
      state.checklistRequestedTemplate = payload;
    },
    SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID: (state, payload) => {
      state.checklistRequestedTemplateDetail = payload;
    },
    SET_IS_SHOW_BUTTON: (state, payload) => {
      state.isShowButton = payload;
    },
    SET_TEMPLATE_EDIT_ID: (state, payload) => {
      state.templateEditId = payload;
    },
    SET_IS_UPDATE_QUESTION_ITEM: (state, payload) => {
      state.isUpdateQuestionItem = payload;
    },
    SET_IS_EXITS_TEMPLATE_NAME: (state, payload) => {
      state.isExitsTemplateName = payload;
    },
    SET_REQUESTED_DETAIL_ITEM: (state, payload) => {
      const AssessmentQuestionTypes =
        store.state.Assessment.assessmentQuestionTypes;
      const checklistRequested = payload.checklistsRequested[0];
      const checklistRequestedItems =
        checklistRequested.checklistRequestedItems.map((item) => {
          // Update note and reset compliance override after vendor update question
          const evaluateLabel = AssessmentQuestionTypes?.find(
            (e) => e.id === item?.checklistItemComplianceTypeOrgId,
          )?.complianceTypeValues.find(
            (i) => i.id === item?.checklistItemComplianceTypeValueOrgId,
          )?.label;

          const generateNoteValue = (overrideText: string) =>
            `${getComponentUiText(
              "app-component-vendor-assessment-note-before-update-answer-1",
              false,
              {
                evaluateValue:
                  evaluateLabel && overrideText
                    ? `${evaluateLabel}`
                    : `${evaluateLabel}. `,
                override: overrideText ? ` ${overrideText}. ` : "",
              },
            )}${item.checklistItemNotesOrgInternal || ""}`;

          const noteValue = item.checklistItemComplianceOverride
            ? generateNoteValue(
                `(${getComponentUiText(
                  "app-component-assessments-override-title-1",
                )}: ${(
                  item.checklistItemComplianceOverride * 100
                ).toFixed()}%)`,
              )
            : generateNoteValue("");

          const isUpdateRequired =
            new Date(item.checklistItemDateUpdated) <
              new Date(item.checklistItemDateUpdatedEmailGrant) &&
            item.checklistItemComplianceTypeValueOrgId !== null;

          if (isUpdateRequired) {
            store.dispatch("Vendor/updateRequestedItems", {
              id: checklistRequested.checklistRequestedId,
              values: [
                {
                  complianceOverride: null,
                  complianceTypeValueOrgId: null,
                  notesOrgInternal: noteValue,
                  checklistRequestedItemId: item.checklistItemId,
                  notesOrgExternal: null,
                },
              ],
            });
          }

          if (
            item.checklistItemAttachments &&
            item.checklistItemAttachments.length
          ) {
            // remove duplicate attachment by id
            item.checklistItemAttachments =
              item.checklistItemAttachments.filter(
                (item, index, self) =>
                  index ===
                  self.findIndex((t) => t.attachmentId === item.attachmentId),
              );
            const attachments = item.checklistItemAttachments.map((item) => {
              const emailGrantId = item.attachmentAddedByEmailGrantId || 0;
              const emailInfo =
                checklistRequested.checklistRequestedEmailGrants.filter(
                  (i) => i.emailGrantId === emailGrantId,
                );

              return {
                ...item,
                name: item.fileNameOriginal,
                size: fileSizeFormat(item.fileSizeBytes),
                date: convertUTCTimeToLocalTime(
                  item.attachmentDateAdded.toString(),
                  undefined,
                  "HH:mm",
                ),
                uploadedBy: { email: emailInfo[0]?.recipientEmail || "" },
              };
            });
            item.additionalData = [
              { type: assessmentAdditionalInfoType.attachment, attachments },
            ];
          } else {
            item.additionalData = [];
          }
          return item;
        });

      state.requestedDetailItem = {
        checklistsRequested: [
          {
            ...checklistRequested,
            checklistRequestedItems,
          },
        ],
      };
    },
    SET_CHECKLIST_VENDOR_REQUESTED_EXTERNAL_INPUT: (state, payload) => {
      const checklistRequesteds = payload.checklistRequestedItems.map(
        (item) => {
          if (
            item.checklistItemAttachments &&
            item.checklistItemAttachments.length
          ) {
            const attachments = item.checklistItemAttachments.map((item) => {
              const emailGrantId = item.attachmentAddedByEmailGrantId || 0;
              const emailInfo = payload.checklistRequestedEmailGrants.filter(
                (i) => i.emailGrantId === emailGrantId,
              );

              return {
                ...item,
                name: item.fileNameOriginal,
                size: fileSizeFormat(item.fileSizeBytes),
                date: convertUTCTimeToLocalTime(
                  item.attachmentDateAdded.toString(),
                  undefined,
                  "HH:mm",
                ),
                uploadedBy: { email: emailInfo[0]?.recipientEmail || "" },
              };
            });
            item.additionalData = [
              { type: assessmentAdditionalInfoType.attachment, attachments },
            ];
          } else {
            item.additionalData = [];
          }
          return item;
        },
      );
      state.checklistVendorRequestedExternalInput = {
        ...payload,
        checklistRequestedItems: checklistRequesteds,
      };
    },
    SET_ADD_TEMPLATE_ITEM_STATUS: (state, payload) => {
      // find the item in the array and replace it
      const index = state.addTemplateItemStatus.findIndex(
        (item) => item.id === payload.id,
      );
      if (index === -1) {
        state.addTemplateItemStatus.push(payload);
      } else {
        if (payload.status === VENDOR_TEMPLATE_API_STATUS.remove) {
          state.addTemplateItemStatus.splice(index, 1);
          return;
        }
        if (payload.newId) {
          payload.id = payload.newId;
        }
        state.addTemplateItemStatus.splice(index, 1, payload);
      }
    },
    SET_CHECKLIST_COMPLIANCE_TYPE_VALUES: (state, payload) => {
      state.checklistComplianceTypeValues = payload;
    },
    SET_CHECKLIST_COMPLIANCE_TYPE_VALUES_CLRA: (state, payload) => {
      state.checklistComplianceTypeValuesClra = payload;
    },
    SET_IS_UPDATED_REQUESTED_ITEMS_DONE: (state, payload) => {
      state.isUpdateRequestedItemsDone = payload;
    },
    SET_IS_SHOW_ARCHIVED_CHECKLIST: (state, payload: boolean) => {
      localStorage.setItem(
        localStorageKey.vendorManageShowArchivedAssessment,
        JSON.stringify(payload),
      );

      state.isShowArchivedChecklist = payload;
    },

    SET_IS_SHOW_ARCHIVED_TEMPLATES: (state, payload: boolean) => {
      localStorage.setItem(
        localStorageKey.vendorManageShowArchivedTemplate,
        JSON.stringify(payload),
      );

      state.isShowArchivedTemplate = payload;
    },

    SET_INCLUDE_HOME_ORG_TEMPLATE: (state, payload: boolean) => {
      localStorage.setItem(
        localStorageKey.vendorManageIncludeHomeOrgTemplate,
        JSON.stringify(payload),
      );

      state.includeHomeOrgTemplate = payload;
    },

    SET_RECENT_SEARCH: (state, payload: string) => {
      if (!payload || !payload.trim() || payload.length === 0) return;

      const recentSearch = state.recentSearch;
      const index = recentSearch.findIndex(
        (item) => item.searchData.text === payload,
      );

      if (index !== -1) recentSearch.splice(index, 1);

      recentSearch.unshift({ searchData: { text: payload } });

      // remove the last item if the length is greater than 5
      if (recentSearch.length > 5) recentSearch.pop();

      state.recentSearch = recentSearch;
    },

    CLEAR_RECENT_SEARCH: (state) => {
      state.recentSearch = [];
    },
    SET_TOTAL_REQUESTED_CHECKLIST_ARCHIVED: (state, payload: number) => {
      state.totalRequestedChecklistArchived = payload;
    },
  },

  actions: {
    fetchExternalRequestedEmailGrant: async (
      { state },
      { checklistRequestedId, emailGrantId, providerId },
    ) => {
      try {
        if (!emailGrantId) return;
        const res = await getRequestedEmailGrant({
          checklistRequestedId,
          emailGrantId,
        });
        const data = get(res, "data.data", {});
        const index = state.requestedChecklist.findIndex(
          (item) => item.providerId === providerId,
        );
        if (
          state.requestedChecklist[index].checklistRequestedId ===
          checklistRequestedId
        ) {
          state.requestedChecklist[index].dataEmailGrant = data;
        }
        const historyIndex = state.requestedChecklist[
          index
        ].checklistRequestedHistory.findIndex(
          (item) => item.checklistRequestedId === checklistRequestedId,
        );
        state.requestedChecklist[index].checklistRequestedHistory[
          historyIndex
        ].dataEmailGrant = data;
      } catch (error) {
        showErrorAPI(error, Vendor.getChecklistRequestedEmailGrant);
      }
    },
    fetchRequestedChecklist: async ({ commit }, payload) => {
      try {
        const res = await getRequestedAssessment({ includeArchived: true });

        const totalRequestChecklistArchived = res.data.data.filter(
          (item) => item.isArchived === true,
        ).length;

        const list = payload.isArchived
          ? res.data.data
          : res.data.data
              .filter((item) => item.isArchived === false)
              .sort((a, b) => {
                return (
                  new Date(b.dateAdded).getTime() -
                  new Date(a.dateAdded).getTime()
                );
              });
        commit("SET_REQUESTED_CHECKLIST", list);
        commit(
          "SET_TOTAL_REQUESTED_CHECKLIST_ARCHIVED",
          totalRequestChecklistArchived,
        );
      } catch (error) {
        showErrorAPI(error, Vendor.getRequestedAssessment);
      }
    },
    postChecklistRequested: async ({ commit }, payload) => {
      try {
        const res = await postChecklistRequested(payload);
        const data = get(res, "data.data", {});
        commit(
          "SET_CHECKLIST_REQUESTED_ID",
          data.checklistsRequested[0].checklistRequestedId,
        );
      } catch (error) {
        const type: string = get(error, "data.error.type", "");
        if (Object.values(ExceptionTypes).includes(type as ExceptionTypes)) {
          showErrorAPI(error, Vendor.postRequestedAssessment);
        } else {
          const message = getComponentUiText(
            "app-api-error-invalid-email-assessment-to-vendor-1",
          );
          const emitData: IToastMessage = {
            variant: ToastVariant.ERROR,
            message,
          };
          EventEmitter.emit(
            EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
            emitData,
          );
        }
        throw Error;
      }
    },
    postChecklistRequestedGetSecret: async ({ state, commit }, body) => {
      try {
        const res = await postChecklistRequestedGetSecret(body.payload);
        if (body.providerId) {
          const data = get(res, "data.data", {});
          let index = state.requestedChecklist.findIndex(
            (item) => item.checklistRequestedId === body.checklistRequestedId,
          );
          if (index !== -1) {
            state.requestedChecklist[index].dataEmailGrant = data;
          } else {
            index = state.requestedChecklist.findIndex(
              (item) => item.providerId === body.providerId,
            );
          }
          const historyIndex = state.requestedChecklist[
            index
          ].checklistRequestedHistory.findIndex(
            (item) => item.checklistRequestedId === body.checklistRequestedId,
          );
          state.requestedChecklist[index].checklistRequestedHistory[
            historyIndex
          ].dataEmailGrant = data;
        }
        const data = get(res, "data.data", {});
        commit("SET_SECRET", data.secret);
      } catch (error) {
        showErrorAPI(error, Vendor.postChecklistRequestedGetSecret);
        throw Error;
      }
    },
    deleteProvider: async ({ state }, id) => {
      const res = await postVendorProviders({
        id,
        isArchived: true,
      });

      if (res?.id) {
        showSuccessToast(
          getComponentUiText(
            "app-modal-manage-vendor-delete-vendor-success-toast-1",
          ),
        );
        state.listProvider = state.listProvider.filter(
          (item) => item.id !== id,
        );
        return true;
      }
    },
    addProvider: async ({ state }, payload) => {
      const res = await postVendorProviders(payload);

      if (res?.id) {
        if (payload.id) {
          showSuccessToast(
            getComponentUiText(
              "app-modal-manage-vendor-edit-vendor-success-toast-1",
            ),
          );
          state.listProvider = state.listProvider.map((item) => {
            if (item.id == payload.id) {
              return res;
            }
            return item;
          });
        } else {
          showSuccessToast(
            getComponentUiText(
              "app-modal-manage-vendor-create-vendor-success-toast-1",
            ),
          );
          state.listProvider.push(res);
        }
        return true;
      }
    },
    fetchProviderList: async ({ state }) => {
      try {
        state.isLoadingCurrentVendors = true;
        const res = await getWizardQuestion("sections[]=providers");
        state.listProvider = get(
          res,
          "data.data.sections[0].questions[0].values",
          [],
        );
      } catch (error) {
        showErrorAPI(error, Org.getOrgSetup);
      } finally {
        state.isLoadingCurrentVendors = false;
      }
    },
    updateChecklistRequested: async (_, payload) => {
      try {
        await putChecklistRequested(payload);
        await store.dispatch("Vendor/fetchRequestedChecklist", {
          isArchived: false,
        });
        return true;
      } catch (error) {
        showErrorAPI(error, Vendor.putRequestedAssessment);
        return false;
      }
    },
    setAddTemplateItemStatus: ({ commit }, payload) => {
      commit("SET_ADD_TEMPLATE_ITEM_STATUS", payload);
    },
    fetchRequestedTemplate: async ({ state, commit }) => {
      state.isLoadinggetRequestedTemplate = true;
      try {
        const includeArchived = store.state.Vendor.isShowArchivedTemplate;
        const includeHomeOrg = store.state.Vendor.includeHomeOrgTemplate;

        const res = await getChecklistRequestedTemplate({
          includeArchived,
          includeHomeOrg,
        });

        const data = get(res, "data.data", {});
        // order by templateOrder
        data.templates.sort((a, b) => {
          return a.templateOrder - b.templateOrder;
        });
        commit("SET_CHECKLIST_REQUESTED_TEMPLATE", data.templates);
      } catch (error) {
        showErrorAPI(error, Vendor.getRequestedTemplate);
      } finally {
        state.isLoadinggetRequestedTemplate = false;
      }
    },
    fetchRequestedTemplateDetail: async ({ state, commit }, { templateId }) => {
      try {
        state.checklistRequestedTemplateDetailLoading = true;
        const res = await getRequestedTemplateDetail(templateId);
        const data = get(res, "data.data.templates", {});
        commit("SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", data);
        commit("SET_ADD_TEMPLATE_ITEM_STATUS", []);
      } catch (error) {
        showErrorAPI(error, Vendor.requestedTemplateDetail);
      } finally {
        state.checklistRequestedTemplateDetailLoading = false;
      }
    },
    fetchRequestedDetailItems: async ({ state, commit }, { requestedId }) => {
      try {
        state.isLoadingRequestedItem = true;
        const res = await getRequestedDetailItem(requestedId);
        const data = get(res, "data.data", {});
        await commit("SET_REQUESTED_DETAIL_ITEM", data);
      } catch (error) {
        showErrorAPI(error, Vendor.getRequestedDetailItem);
      } finally {
        setTimeout(() => {
          state.isLoadingRequestedItem = false;
        }, 1000);
      }
    },
    updateChecklistRequestedTemplateItem: async ({ commit, state }, data) => {
      // repleace the item in the array
      const items = state.checklistRequestedTemplateDetail[0].items;
      const index = items.findIndex(
        (item) => item.itemMasterId === data.data.itemMasterId,
      );
      items.splice(index, 1, data.data);

      commit("SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", [
        { ...state.checklistRequestedTemplateDetail[0], items },
      ]);
    },
    fetchVendorRequestedExternalInput: async ({ commit, state }) => {
      try {
        state.isLoadingRequestedInput = true;
        const res = await getVendorRequestedExternalInput();
        const data = get(res, "data.data.checklistsRequested[0]", {});

        if (
          data.statusId === checklistRequestedStatusId.created ||
          data.statusId === checklistRequestedStatusId.defunct ||
          data.statusId === checklistRequestedStatusId.completed
        ) {
          router.push({
            name: "VendorAssessmentsExternalSorry",
          });
        } else {
          router.push({ name: "AssessmentVendorInput" });
        }
        commit("SET_CHECKLIST_VENDOR_REQUESTED_EXTERNAL_INPUT", data);
      } catch (error) {
        router.push({
          name: "VendorAssessmentsExternalSorry",
        });
        showErrorAPI(error, Vendor.vendorRequestedExternalInput);
      } finally {
        state.isLoadingRequestedInput = false;
      }
    },
    updateVendorRequestedExternalInput: async ({ state, commit }, data) => {
      try {
        const checklistRequestedId =
          state.checklistVendorRequestedExternalInput?.checklistRequestedId;

        if (!checklistRequestedId) return;

        const res = await updateRequestedAssessment(checklistRequestedId, data);
        commit(
          "SET_CHECKLIST_VENDOR_REQUESTED_EXTERNAL_INPUT",
          get(res, "data.data.checklistsRequested[0]", {}),
        );
        return true;
      } catch (error) {
        showErrorAPI(error, Vendor.putChecklistRequestedItems);
        return false;
      }
    },
    addAttachmentItemChecklistRequestedExternalInput: async (
      { state, commit },
      data,
    ) => {
      try {
        const checklistRequested = state.checklistVendorRequestedExternalInput;
        const checklistRequestedItems =
          checklistRequested.checklistRequestedItems;
        checklistRequestedItems.forEach((item) => {
          if (item.checklistItemId === data.checklistItemId) {
            item.checklistItemAttachments =
              item.checklistItemAttachments &&
              item.checklistItemAttachments.length
                ? [...item.checklistItemAttachments, ...[data.attachments]]
                : [data.attachments];
          }
        });
        commit("SET_CHECKLIST_VENDOR_REQUESTED_EXTERNAL_INPUT", {
          ...checklistRequested,
          checklistRequestedItems,
        });
        return true;
      } catch (error) {
        showErrorAPI(error, Vendor.putChecklistRequestedItems);
        return false;
      }
    },
    delAttachmentItemChecklistRequestedExternalInput: async (
      { state, commit },
      data,
    ) => {
      try {
        const checklistRequested = state.checklistVendorRequestedExternalInput;
        const checklistRequestedItems =
          checklistRequested.checklistRequestedItems;
        checklistRequestedItems.forEach((item) => {
          if (item.checklistItemId === data.checklistItemId) {
            data.attachmentIds.forEach((attachmentId) => {
              const index = item.checklistItemAttachments.findIndex(
                (item) => item.attachmentId === attachmentId,
              );
              index !== -1 && item.checklistItemAttachments.splice(index, 1);
            });
          }
        });
        commit("SET_CHECKLIST_VENDOR_REQUESTED_EXTERNAL_INPUT", {
          ...checklistRequested,
          checklistRequestedItems,
        });
        return true;
      } catch (error) {
        showErrorAPI(error, Vendor.putChecklistRequestedItems);
        return false;
      }
    },

    delAttachmentItemChecklistRequestedInput: async ({ state }, data) => {
      try {
        const checklistRequested =
          state.requestedDetailItem.checklistsRequested[0];
        const checklistRequestedItems =
          checklistRequested.checklistRequestedItems;
        checklistRequestedItems.forEach((item) => {
          if (item.checklistItemId === data.checklistItemId) {
            data.attachmentIds.forEach((attachmentId) => {
              const index = item.checklistItemAttachments.findIndex(
                (item) => item.attachmentId === attachmentId,
              );
              index !== -1 && item.checklistItemAttachments.splice(index, 1);
              const indexAddition =
                item.additionalData[0].attachments.findIndex(
                  (item) => item.attachmentId === attachmentId,
                );
              indexAddition !== -1 &&
                item.additionalData[0].attachments.splice(indexAddition, 1);
            });
          }
        });
        state.requestedDetailItem = {
          checklistsRequested: [
            {
              ...checklistRequested,
              checklistRequestedItems,
            },
          ],
        };
        return true;
      } catch (error) {
        showErrorAPI(error, Vendor.putChecklistRequestedItems);
        return false;
      }
    },
    fetchChecklistRequestedComplianceTypeValues: async (
      { commit },
      checklistContextIds = "",
    ) => {
      try {
        const res =
          await getChecklistRequestedComplianceTypeValues(checklistContextIds);
        const data = get(res, "data.data.complianceTypes", []);
        if (checklistContextIds === "clra") {
          commit("SET_CHECKLIST_COMPLIANCE_TYPE_VALUES_CLRA", data);
        } else {
          commit("SET_CHECKLIST_COMPLIANCE_TYPE_VALUES", data);
        }
      } catch (error) {
        showErrorAPI(error, Vendor.getChecklistRequestedComplianceTypeValues);
      }
    },
    fetchVendorRequestedExternalAttachment: async (_, attachmentId) => {
      try {
        const res = await getRequestAssessmentAttachment(attachmentId);
        return res;
      } catch (error) {
        showErrorAPI(error, Vendor.getRequestAssessmentAttachment);
      }
    },
    fetchVendorRequestedAttachment: async (_, attachmentId) => {
      try {
        const res = await getRequestVendorAssessmentAttachment(attachmentId);
        return res;
      } catch (error) {
        showErrorAPI(error, Vendor.getRequestAssessmentAttachment);
      }
    },
    updateChecklistRequestedEmailGrant: async ({ state }, { params, body }) => {
      try {
        state.isLoadingRequestedItem = true;
        const res = await updateChecklistRequestedEmailGrant(params, body);
        const data = get(res, "data.data", {});
        let index = state.requestedChecklist.findIndex(
          (item) => item.checklistRequestedId === params.checklistRequestedId,
        );
        if (index !== -1) {
          state.requestedChecklist[index].dataEmailGrant = data;
        } else {
          index = state.requestedChecklist.findIndex(
            (item) => item.providerId === params.providerId,
          );
        }
        const historyIndex = state.requestedChecklist[
          index
        ].checklistRequestedHistory.findIndex(
          (item) => item.checklistRequestedId === params.checklistRequestedId,
        );
        state.requestedChecklist[index].checklistRequestedHistory[
          historyIndex
        ].dataEmailGrant = data;
      } catch (error) {
        showErrorAPI(error, Vendor.putChecklistRequestedEmailGrant);
      } finally {
        state.isLoadingRequestedItem = false;
      }
    },
    postChecklistRequestedStatus: async (
      { state },
      { params, body, isNoneLoading, onlyUpdateStatus },
    ) => {
      try {
        !isNoneLoading && (state.isLoadingRequestedItem = true);
        const res = await createChecklistRequestedStatus(params, body);

        if (onlyUpdateStatus) return true;

        const data = get(res, "data.data", {});
        const index = state.requestedChecklist.findIndex(
          (item) => item.providerId === params.providerId,
        );
        state.requestedChecklist[index].statusId = data["statusId"];
        state.requestedChecklist[index].status = data["status"];
        state.requestedChecklist[index].statusAsAtDate = data["statusAsAtDate"];
        const historyIndex = state.requestedChecklist[
          index
        ].checklistRequestedHistory.findIndex(
          (item) => item.checklistRequestedId === params.checklistRequestedId,
        );
        state.requestedChecklist[index].checklistRequestedHistory[
          historyIndex
        ].statusId = data["statusId"];
        state.requestedChecklist[index].checklistRequestedHistory[
          historyIndex
        ].status = data["status"];
        state.requestedChecklist[index].checklistRequestedHistory[
          historyIndex
        ].statusAsAtDate = data["statusAsAtDate"];
      } catch (error) {
        showErrorAPI(error, Vendor.postChecklistRequestedStatus);
        throw error;
      } finally {
        !isNoneLoading && (state.isLoadingRequestedItem = false);
      }
    },
    updateRequestedItems: async ({ commit }, { id, values }) => {
      try {
        const res = await putRequestedUpdatedItems(id, values);
        const data = get(res, "data.data", {});
        if (res.status === successStatusCodes.OK) {
          commit("SET_IS_UPDATED_REQUESTED_ITEMS_DONE", true);
          commit("SET_REQUESTED_DETAIL_ITEM", data);
          return true;
        }
        true;
        return false;
      } catch (error) {
        commit("SET_IS_UPDATED_REQUESTED_ITEMS_DONE", false);
        showErrorAPI(error, Vendor.putRequestedDetailItem);
        return false;
      } finally {
        commit("SET_IS_UPDATED_REQUESTED_ITEMS_DONE", false);
      }
    },
    fetchChecklistRequestedEmailGrants: async (_, requestedChecklistId) => {
      try {
        const res =
          await getChecklistRequestedEmailGrants(requestedChecklistId);
        const data = get(res, "data.data", {});
        return data;
      } catch (error) {
        showErrorAPI(error, Vendor.getChecklistRequestedEmailGrants);
      }
    },
  },
};

export default vendorModule;
